import React, { useState } from 'react';

/**
 * LazyImage component - loads images only when visible
 * Includes blur-up placeholder effect
 */
const LazyImage = ({
  src,
  alt,
  className = '',
  placeholderSize = 'w-full h-full',
  objectFit = 'cover',
  onLoad = () => {},
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const imageRef = React.useRef(null);

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        rootMargin: '50px', // Start loading 50px before image enters viewport
      }
    );

    const currentRef = imageRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const handleLoad = () => {
    setIsLoaded(true);
    onLoad();
  };

  return (
    <img
      ref={imageRef}
      src={isVisible ? src : 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 300"%3E%3C/svg%3E'}
      alt={alt}
      className={`${className} ${
        isLoaded ? 'opacity-100' : 'opacity-40'
      } transition-opacity duration-300`}
      style={{ objectFit }}
      onLoad={handleLoad}
      loading="lazy"
    />
  );
};

export default LazyImage;
